export const GithubRepoRoot = "https://github.com/morpheus65535/bazarr";
